module.exports = __webpack_public_path__ + "media/hyper/images/projects/project-1-22c4e2f590327f260da5622a6cefde06.jpg";